import React, {Component} from 'react';
import FilterGenerateList from '../parts/FilterGenerateList';
import Axios from 'axios';
import APIENDPOINT from '../ApiEndpoint';
//

class DuurLes extends Component {
    constructor(props){
        super(props);
        this.state = {
            types: [],
            typesfull: [],
            filterOptions: []
        }
    }
    
    async componentDidMount(){
        const {data} = await Axios.get(`${APIENDPOINT}/types`);

        this.setState({typesfull : Object.values(data) });
    }

    findFilterOptions = (needle) => {
        if(this.state.typesfull.length > 0){
            const typeOptions = this.state.typesfull.find(type => type.type_name === needle).options;
             return typeOptions;

        }else{
            return [];
        }
    }
    render(){
        const filtersOptions = this.findFilterOptions("Duur les");
        return(
            <FilterGenerateList title='Selecteer duur les' filterOptions={filtersOptions}/>
        )
    }
}

export default DuurLes;